import * as Preact from 'preact';
import { useEffect } from 'react';
import * as Actions from '../../store/actions/app';
import * as Logging from '../../store/actions/log';
import { useDispatch } from '../../store/redux';
import { useErrorBoundary, useState } from 'preact/hooks';
import * as Initialisation from '../../store/initialisation';

class UnhandledPromiseRejectionError extends Error {
    constructor(private rejection: PromiseRejectionEvent) {
        super('Unexpected Unhandled Promise Rejection has been found');
    }
}

const BubbleUnhandledPromiseRejection = (props: { children: Preact.ComponentChildren }) => {
    const [unhandledError, setUnhandledError] = useState<null | Error>(null);

    useEffect(() => {
        const handle = (evt: PromiseRejectionEvent) => {
            setUnhandledError(new UnhandledPromiseRejectionError(evt));
        };
        // Global Unhandled Promise Rejection catch
        window.addEventListener('unhandledrejection', handle);
        return () => {
            window.removeEventListener('unhandledrejection', handle);
        };
    }, []);

    if (unhandledError !== null) {
        setUnhandledError(null);
        throw unhandledError;
    }

    return <>{props.children}</>;
};

/**
 * @param props.children: Components to render if no error has been thrown.
 */
export const StellaErrorBoundary = (props: { children: Preact.ComponentChildren }) => {
    const [error, resetError] = useErrorBoundary();

    const dispatch = useDispatch();

    useEffect(() => {
        if (error) {
            dispatch(Actions.globalErrorAction(error.message));
            dispatch(Logging.logError(`Caught Global Error: ${error.message}`));

            dispatch(Initialisation.error());

            resetError();
        }
    }, [error]);

    return <BubbleUnhandledPromiseRejection>{props.children}</BubbleUnhandledPromiseRejection>;
};
